export function toBuf(value: string | Uint8Array): Uint8Array {
  let buf: Uint8Array
  if (typeof value === "string") {
    buf = fromUtf8ToArray(value)
  } else {
    buf = value
  }
  return buf
}

export function toWebCryptoAlgorithm(
  algorithm: "sha1" | "sha256" | "sha512" | "md5",
): string {
  if (algorithm === "md5") {
    throw new Error("MD5 is not supported in WebCrypto.")
  }
  return algorithm === "sha1"
    ? "SHA-1"
    : algorithm === "sha256"
      ? "SHA-256"
      : "SHA-512"
}

export function toWebCryptoAesMode(mode: "cbc" | "ecb"): string {
  return mode === "cbc" ? "AES-CBC" : "AES-ECB"
}

export function fromUtf8ToArray(str: string): Uint8Array {
  const strUtf8 = unescape(encodeURIComponent(str))
  const arr = new Uint8Array(strUtf8.length)
  for (let i = 0; i < strUtf8.length; i++) {
    arr[i] = strUtf8.charCodeAt(i)
  }
  return arr
}

export function fromByteStringToArray(str: string): Uint8Array {
  const arr = new Uint8Array(str.length)
  for (let i = 0; i < str.length; i++) {
    arr[i] = str.charCodeAt(i)
  }
  return arr
}

export function usernameToSalt(email: string) {
  return email.toLowerCase().trim()
}

export function fromBufferToBase64(buffer: ArrayBuffer): string {
  let binary = ""
  const bytes = new Uint8Array(buffer)
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i])
  }
  return window.btoa(binary)
}

// Helper to convert ArrayBuffer to Base64
export function arrayBufferToBase64(
  buffer: ArrayBuffer | SharedArrayBuffer,
): string {
  let binary = ""
  const bytes = new Uint8Array(buffer)
  const len = bytes.byteLength
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i])
  }
  return window.btoa(binary)
}

// Helper to convert Base64 to ArrayBuffer
export function base64ToArrayBuffer(base64: string): ArrayBuffer {
  const binary_string = window.atob(base64)
  const len = binary_string.length
  const bytes = new Uint8Array(len)
  for (let i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i)
  }
  return bytes.buffer
}
